import videojs, { VideoJsPlayer } from 'video.js';

import { Event } from '@src/types/event';
import { getIsMac } from '@src/utils/device';

const MenuButton = videojs.getComponent('MenuButton');

class CustomMenuButton extends MenuButton {
  constructor(player: VideoJsPlayer, options: videojs.MenuButtonOptions) {
    super(player, options);
    this.setupHandleMouseDown();
  }

  // focus on mousedown/mouseclick events are omitted on safari/firefox of macOS
  // causing the MenuButton.handleBlur not working expectedly
  setupHandleMouseDown() {
    this.on('mousedown', () => {
      const isMac = getIsMac();
      if (isMac && (videojs.browser.IS_SAFARI || videojs.browser.IS_FIREFOX)) {
        this.focus();
      }
    });
  }

  createMenu() {
    const menu = super.createMenu();

    const originalShowMenu = menu.show?.bind(menu);
    const originalHideMenu = menu.hide?.bind(menu);

    menu.show = () => {
      originalShowMenu?.();
      // setTimeout to await DOM of menu update
      setTimeout(() => {
        menu.trigger(Event.X_MENU_SHOW);
      }, 0);
    };

    menu.hide = () => {
      originalHideMenu?.();
      // setTimeout to await DOM of menu update
      setTimeout(() => {
        menu.trigger(Event.X_MENU_HIDE);
      }, 0);
    };

    menu.on(Event.X_MENU_SHOW, () => {
      const playerHeight = this.player_.currentHeight();
      const playerEl = this.player_.el();
      const playerRect = playerEl?.getBoundingClientRect();

      const menuContentEl = this.menu.contentEl() as HTMLDivElement;
      const menuContentRect = menuContentEl?.getBoundingClientRect() ?? {};

      if (!menuContentRect || !playerRect) return;

      const menuContentMaxHeight =
        playerHeight - (playerRect.bottom - menuContentRect.bottom) - 12;

      if (menuContentMaxHeight > 0) {
        menuContentEl.style.setProperty(
          '--menu-max-height',
          `${menuContentMaxHeight}px`
        );
      }
    });

    return menu;
  }
}

// override video.js original MenuButton
videojs.registerComponent('MenuButton', CustomMenuButton);

export default CustomMenuButton;
